import { useEffect, type ReactNode } from "react";
import { useTranslation } from "react-i18next";
import { LandingHeader } from "./LandingHeader";
import { LandingFooter } from "./LandingFooter";
import "../landing.css";

type LandingLayoutProps = {
  children: ReactNode;
};

export function LandingLayout({ children }: LandingLayoutProps) {
  const { i18n } = useTranslation();

  useEffect(() => {
    document.documentElement.lang = i18n.language;
  }, [i18n.language]);

  // When arriving with a section hash (e.g. from the Legal pages' WHY / HOW
  // links), scroll to that section once it has mounted. The browser's native
  // hash scroll fires before React renders the sections, so retry for a few
  // frames until the target element exists.
  useEffect(() => {
    const id = window.location.hash.slice(1);
    if (!id) return;
    let frames = 0;
    const tick = () => {
      const el = document.getElementById(id);
      if (el) {
        el.scrollIntoView();
      } else if (frames++ < 20) {
        requestAnimationFrame(tick);
      }
    };
    requestAnimationFrame(tick);
  }, []);

  return (
    <div className="landing-root relative flex min-h-screen flex-col bg-[#070A0B] font-sans text-[#E2EDE7] antialiased">
      <div aria-hidden className="bp-canvas" />
      <div className="relative z-10 flex min-h-screen flex-col">
        <LandingHeader />
        <main className="flex-1">{children}</main>
        <LandingFooter />
      </div>
    </div>
  );
}

export default LandingLayout;
